import MuiDataGrid from './MuiDataGrid';

const overrides = {
  MuiDataGrid,
};

export default overrides;
